module.exports = __webpack_public_path__ + "static/image/history/pc/202510.ver2_0_2.jpg?5637f3c1";